var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05146 4.43748L2.2298 0.615817C1.9953 0.381432 1.6773 0.2498 1.34576 0.249878C1.01421 0.249956 0.696271 0.381738 0.461886 0.616234C0.227501 0.850729 0.0958692 1.16873 0.0959473 1.50028C0.0960254 1.83183 0.227808 2.14977 0.462303 2.38415L4.28396 6.20498C4.32277 6.24369 4.35355 6.28967 4.37456 6.34029C4.39556 6.39091 4.40637 6.44518 4.40637 6.49998C4.40637 6.55479 4.39556 6.60906 4.37456 6.65968C4.35355 6.7103 4.32277 6.75628 4.28396 6.79498L0.462303 10.6158C0.227808 10.8502 0.0960254 11.1681 0.0959473 11.4997C0.0958692 11.8312 0.227501 12.1492 0.461886 12.3837C0.696271 12.6182 1.01421 12.75 1.34576 12.7501C1.6773 12.7502 1.9953 12.6185 2.2298 12.3842L6.05146 8.56248C6.59749 8.01495 6.90411 7.27325 6.90411 6.49998C6.90411 5.72672 6.59749 4.98501 6.05146 4.43748Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.b4051478a1c0acc66ac5a82cc902ac57.svg";
export { ForwardRef as ReactComponent };